import { useState } from 'react';
import { useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CloudOff } from 'lucide-react';
import { Button } from '@repo/ui/components/molecules/button';
import { useLocalSignOut } from '@/lib/auth/use-local-sign-out';

/**
 * Schermata di `/me` non riuscita (5xx o rete): il server non ha detto se la
 * sessione c'è, quindi non si manda al login da soli. «Riprova» rifà i
 * `beforeLoad` della rotta (e con loro la lettura di `/me`, che non resta in
 * cache dopo un errore); «Torna al login» chiude la sessione lato client.
 */
export function SessionCheckErrorPage() {
  const { t } = useTranslation();
  const router = useRouter();
  const signOutLocally = useLocalSignOut();
  const [isRetrying, setIsRetrying] = useState(false);

  const retry = async () => {
    setIsRetrying(true);
    try {
      await router.invalidate();
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-4">
      <div
        role="alert"
        className="flex max-w-md flex-col items-center gap-4 text-center"
      >
        <span
          aria-hidden="true"
          className="flex size-12 items-center justify-center rounded-lg bg-bad-soft text-bad-text"
        >
          <CloudOff className="size-6" />
        </span>
        <div className="flex flex-col gap-1.5">
          <h1 className="text-xl font-semibold text-foreground">
            {t('auth.session_check_error.title')}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t('auth.session_check_error.description')}
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-2">
          <Button variant="outline" onClick={() => void signOutLocally()}>
            {t('auth.back_to_sign_in')}
          </Button>
          <Button loading={isRetrying} onClick={() => void retry()}>
            {t('commons.try_again')}
          </Button>
        </div>
      </div>
    </main>
  );
}
